import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "dashboax" };
const prefix = "/Dashboax/Graphics/Doabfact";

export const doabfactApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataDoabfact: builder.query({
      query: (params) => ({
        url: prefix,
        method: "GET",
        headers,
        params,
      }),
    }),
  }),
});

export const { useLazyGetDataDoabfactQuery } = doabfactApiSlice;
